import { Database } from '@nozbe/watermelondb'
import { Chat } from '../model'
import { ComponentInfoLoadChatsVO } from '@repo/types'
import { getChatListFiltersPredicate } from '../predicates'

export const getChatsUnreadsSum = async (
  database: Database,
  filters: ComponentInfoLoadChatsVO
): Promise<number | undefined> => {
  try {
    const chats = database.collections.get<Chat>('chats')
    return await database.read(async () => {
      const fetchChats = await chats.query(getChatListFiltersPredicate(filters)).fetch()
      return fetchChats?.map(chat => chat.unreads).reduce((acc, unreads) => acc + unreads, 0)
    })
  } catch (e) {
    console.error(e)
  }
}
